<template>
  <div>
    <v-layout row>
      <v-flex xs6>
        <v-menu
          ref="menu"
          v-model="menu"
          :close-on-content-click="false"
          :nudge-right="40"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          min-width="290px"
        >
          <v-text-field
            slot="activator"
            label="Date:"
            :value="prettyDate(bol.date)"
            prepend-icon="event"
            readonly
          ></v-text-field>
          <v-date-picker v-model="bol.date" no-title scrollable @input="menu = false">
            <!-- <v-btn flat color="primary" @click="menu = false">Cancel</v-btn>
            <v-btn flat color="primary" @click="saveDate(bol.date)">OK</v-btn> -->
          </v-date-picker>
        </v-menu>
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex xs6>
        <h4>Direction</h4>
        <v-radio-group v-model="bol.direction">
          <v-radio label="IN" value="IN"></v-radio>
          <v-radio label="OUT" value="OUT"></v-radio>
        </v-radio-group>
      </v-flex>
      <v-flex xs6>
        <h4>Tax Status</h4>
        <v-radio-group v-model="bol.bonded">
          <v-radio label="Bond to Bond" value="BONDTOBOND"></v-radio>
          <v-radio label="Tax Paid" value="TAXPAID"></v-radio>
        </v-radio-group>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import myMixins from '../mixins/myMixins'

export default {
  props: ['bol'],
  data () {
    return {
      menu: false
    }
  },
  mixins: [myMixins],
  created () {
  },
  computed: {
    facilities () {
      return this.$store.state.facilities
    },
    lots () {
      return this.$store.state.lotsForVintage
    },
    vintage () {
      return this.$store.state.vintage
    },
    clientcode () {
      return this.$store.state.client.CODE
    },
    client () {
      return this.$store.state.client
    }
  },
  methods: {
    saveDate (date) {
      this.bol.date = moment(date).add(5, 'hours').format('YYYY-MM-DDThh:mm:ss')
      this.menu = false
    },
    facilityChanged (value) {

    }
  }
}
</script>
<style>
</style>
